module.exports = __webpack_public_path__ + "img/antes_despues_260.0a0438ea.png";